var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.gettingChatRooms,
          expression: "gettingChatRooms"
        }
      ]
    },
    [
      _c(
        "div",
        {
          staticClass: "govgr-header__container",
          staticStyle: { color: "#fff" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "govgr-phase-banner" },
            [
              _vm.currentUser
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        title: "Ειδοποιήσεις - Μηνύματα",
                        visible: _vm.chatDialogVisible,
                        width: "95%"
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.chatDialogVisible = $event
                        }
                      }
                    },
                    [_c("Chat")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentUser
                ? _c(
                    "div",
                    {
                      staticClass: "gov-user-box navbar-user hidden-sm-and-down"
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.translation(_vm.activeRole)) +
                          ": " +
                          _vm._s(_vm.userNameSurname) +
                          "\n    "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentUser
                ? _c(
                    "el-button",
                    { staticClass: "timer-button", on: { click: _vm.refresh } },
                    [
                      _c("countdown", {
                        staticClass: "clock",
                        attrs: { time: _vm.time }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentUser
                ? _c(
                    "span",
                    { staticStyle: { "padding-right": "20px" } },
                    [
                      _vm.haveNewMessages
                        ? _c(
                            "el-badge",
                            { staticClass: "item", attrs: { value: "νέα" } },
                            [
                              _c("el-button", {
                                attrs: {
                                  type: _vm.notificationsType,
                                  icon: "el-icon-message"
                                },
                                on: { click: _vm.listAllNotifications }
                              })
                            ],
                            1
                          )
                        : _c("el-button", {
                            attrs: {
                              type: _vm.notificationsType,
                              icon: "el-icon-message"
                            },
                            on: { click: _vm.listAllNotifications }
                          })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "navbar-account hidden-xs-and-down" },
                [
                  _vm.currentUser
                    ? _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: _vm.activeRole,
                            size: "small"
                          },
                          model: {
                            value: _vm.selectedRole,
                            callback: function($$v) {
                              _vm.selectedRole = $$v
                            },
                            expression: "selectedRole"
                          }
                        },
                        _vm._l(_vm.userScope, function(role, index) {
                          return _c("el-option", {
                            key: role,
                            attrs: {
                              label: _vm.userScopeGr[index],
                              value: role
                            }
                          })
                        })
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentUser
                    ? _c(
                        "el-dropdown",
                        { attrs: { "hide-timeout": 500 } },
                        [
                          _c(
                            "i",
                            {
                              staticClass: "el-icon-arrow-down el-icon--right",
                              staticStyle: { color: "#fff" }
                            },
                            [_vm._v("Λογαριασμός")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      nativeOn: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          _vm.getProfile($event)
                                        }
                                      }
                                    },
                                    [_vm._v("Προφιλ")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-dropdown-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      nativeOn: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          _vm.logout($event)
                                        }
                                      }
                                    },
                                    [_vm._v("Αποσύνδεση")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeRole != null && !_vm.currentUser
                    ? [
                        _c(
                          "router-link",
                          {
                            attrs: { to: "/login" },
                            nativeOn: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.login($event)
                              }
                            }
                          },
                          [
                            _c("el-button", { attrs: { type: "text" } }, [
                              _vm._v("Σύνδεση")
                            ])
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "govgr-header__content" }, [
      _c("a", { attrs: { href: "https://www.gov.gr/" } }, [
        _c("img", {
          staticClass: "govgr-header-logo",
          attrs: { src: "https://www.gov.gr/gov_gr_logo.svg" }
        })
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "https://e-doatap.doatap.gr" } }, [
        _c("img", {
          staticClass: "govgr-header-secondary-logo",
          attrs: {
            src: require("../assets/Logo-eDoatap_Color_white-letters.png")
          }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9ddb17c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ddb17c0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = null
// module chunks = 